function isToGet(scrollTop, scrollHeight, offsetHeight, invert) {
    if (scrollTop && offsetHeight && scrollHeight) {

		if (invert) {
			return (
				Math.abs(scrollTop) >= (scrollHeight / 2) &&
				Math.abs(scrollTop) > 0
			);
		}

        return (
            scrollTop + offsetHeight > scrollHeight / 2 &&
            scrollTop + offsetHeight < scrollHeight
        );
    }

    return false;
}

function getIsMaxPage(count, listSize, currentPage) {
    return listSize * currentPage >= count;
}

function getOffset(listSize, currentPage) {
    return listSize * currentPage;
}

function scrollInfinito(isRetry) {
    async function run(event, configs, invert) {

        const $target = event.target;

        if ($target) {
            let isGet = isToGet(
                $target.scrollTop,
                $target.scrollHeight,
				$target.offsetHeight,
				invert
            );

            let {
                isLoading,
                isSearch,
                isMaxPage,
                listSize,
                currentPage,
                getData,
                filters
            } = configs;

            isGet = isRetry || isGet;

            if (isGet && !isLoading && !isSearch) {

                if (!isMaxPage) {
                    try {
                        configs.isLoading = true;

                        let params = {
                            limit: listSize,
                            offset: getOffset(listSize, currentPage)
                        };

                        if (filters) {
                            params = {...params, ...filters};
                        }

                        const { data, count } = await getData(params);

                        configs.isMaxPage = getIsMaxPage(count, listSize, currentPage);

                        if (isMaxPage) {
                            return data;
                        }

                        configs.currentPage += 1;
                        currentPage += 1;

                        configs.isMaxPage = getIsMaxPage(count, listSize, currentPage);

                        setTimeout(() => {
                            configs.isLoading = false;
                        }, 50);

                        return data;

                    } catch (error) {
                        if (error && error.message === "Network Error") {
                            setTimeout(async () => {
                                configs.isLoading = false;
                                await scrollInfinito(true).run(event, configs);
                            }, 500);

                            return null;
                        }

                        setTimeout(() => {
                            configs.isLoading = false;
                        }, 50);
                    }
                } else {
                    configs.isLoading = false;
                }
            }
        }

    }

    return { run };
}

export default scrollInfinito();
